import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/Models'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ModelsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ModelsStore",
			variables: false,
		})
	}
}

export async function load_Models(params) {
  await initClient()

	const store = new ModelsStore()

	await store.fetch(params)

	return {
		Models: store,
	}
}
